import { Layout, Step, Stepper } from "@mcleod/components";

export abstract class AutogenLayoutProcessingStepper extends Layout {
    stepEditList: Step;
    stepPostingReports: Step;
    stepperProcessing: Stepper;
}
